/**
 * SortableHead — clickable <TableHead> with arrow icon showing sort state.
 *
 * Usage:
 *   <SortableHead sortKey="cognome" sortKeyCurrent={sortKey} sortDir={sortDir} onClick={requestSort}>
 *     Cognome
 *   </SortableHead>
 *
 * Visual feedback:
 *   - inactive column → faded double-arrow icon
 *   - active asc       → up arrow, blue
 *   - active desc      → down arrow, blue
 */
import { ArrowUp, ArrowDown, ChevronsUpDown } from "lucide-react";
import { TableHead } from "./ui/table";

export const SortableHead = ({
    sortKey,
    sortKeyCurrent,
    sortDir,
    onClick,
    children,
    className = "",
    align = "left",
    ...rest
}) => {
    const isActive = sortKeyCurrent === sortKey;
    const Icon = !isActive ? ChevronsUpDown : sortDir === "desc" ? ArrowDown : ArrowUp;

    return (
        <TableHead
            className={`cursor-pointer select-none group ${className}`}
            onClick={() => onClick(sortKey)}
            data-testid={`sort-${sortKey}`}
            aria-sort={!isActive ? "none" : sortDir === "asc" ? "ascending" : "descending"}
            {...rest}
        >
            <span
                className={`inline-flex items-center gap-1 transition-colors ${align === "right" ? "justify-end" : ""} ${isActive ? "text-[#376DB3]" : "text-slate-700 group-hover:text-[#376DB3]"}`}
            >
                {children}
                <Icon
                    className={`h-3.5 w-3.5 flex-shrink-0 transition-opacity ${isActive ? "opacity-100" : "opacity-40 group-hover:opacity-70"}`}
                    aria-hidden
                />
            </span>
        </TableHead>
    );
};
